import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    newUsers: Array,
    completedInterviews: Array,
    newTopics: Array,
  }

  connect() {
    this.initChart()
  }

  disconnect() {
    this.chart?.destroy()
  }

  initChart() {
    this.chart?.destroy()
    const ctx = this.canvasTarget.getContext("2d")
    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: this.labelsValue,
        datasets: [
          {
            label: "新注册用户",
            data: this.newUsersValue,
            borderColor: "#3b82f6",
            backgroundColor: "rgba(59,130,246,0.08)",
            tension: 0.3,
            fill: true,
            pointRadius: 3,
          },
          {
            label: "完成访谈",
            data: this.completedInterviewsValue,
            borderColor: "#14b8a6",
            backgroundColor: "rgba(20,184,166,0.08)",
            tension: 0.3,
            fill: true,
            pointRadius: 3,
          },
          {
            label: "新建项目",
            data: this.newTopicsValue,
            borderColor: "#f59e0b",
            backgroundColor: "rgba(245,158,11,0.08)",
            tension: 0.3,
            fill: true,
            pointRadius: 3,
          },
        ],
      },
      options: {
        responsive: true,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: { position: "top", labels: { font: { size: 12 }, boxWidth: 12 } },
          tooltip: { bodyFont: { size: 12 } },
        },
        scales: {
          x: {
            ticks: { font: { size: 11 }, maxTicksLimit: 14 },
            grid: { display: false },
          },
          y: {
            beginAtZero: true,
            ticks: { font: { size: 11 }, precision: 0 },
            grid: { color: "rgba(0,0,0,0.04)" },
          },
        },
      },
    })
  }
}
